import {Fragment} from 'react';
import {MathText} from './MathText';
import './pedagogical-correction.css';

/** Pipe tables stay plain authoring text; React escapes every cell as usual. */
function tableCells(line:string):string[] {
 const cells:string[]=[];let cell='';
 for(let i=0;i<line.length;i++){
  if(line[i]==='\\'&&line[i+1]==='|'){cell+='|';i++;}
  else if(line[i]==='|'){cells.push(cell.trim());cell='';}
  else cell+=line[i];
 }
 cells.push(cell.trim());
 if(cells[0]==='')cells.shift();
 if(cells.at(-1)==='')cells.pop();
 return cells;
}
export function PedagogicalText({text,tableLabel='Tableau',correction=false}:{text:string;tableLabel?:string;correction?:boolean}) {
 const parts=text.replace(/\r\n?/g,'\n').trim().split(/\n\s*\n/).filter(Boolean);
 return <div className={`pedagogical-text${correction?' student-correction-content':''}`}>{parts.map((part,index)=>{
  const trimmed=part.trim();
  if(/^(?:\\\[[\s\S]*\\\]|\$\$[\s\S]*\$\$)$/.test(trimmed))return <div className="student-correction-equation" key={index}><MathText text={trimmed}/></div>;
  const lines=trimmed.split('\n'),rows=lines.map(tableCells);
  if(lines.every(line=>/^\s*[-•]\s+\S/.test(line)))return <ul className="pedagogical-correction-steps" key={index}>{lines.map((line,step)=><li key={step}><MathText text={line.replace(/^\s*[-•]\s+/,'')}/></li>)}</ul>;
  const isTable=rows.length>=3&&rows[0].length>=2&&rows.every(row=>row.length===rows[0].length)&&rows[1].every(cell=>/^:?-{3,}:?$/.test(cell));
  const alignment=(col:number):'left'|'center'|'right'=>rows[1][col].endsWith(':')?(rows[1][col].startsWith(':')?'center':'right'):'left';
  if(isTable)return <div className="pedagogical-correction-table" key={index} tabIndex={0} role="region" aria-label={tableLabel}><table>
   <thead><tr>{rows[0].map((cell,col)=><th key={col} scope="col" style={{textAlign:alignment(col)}}><MathText text={cell}/></th>)}</tr></thead>
   <tbody>{rows.slice(2).map((row,line)=><tr key={line}>{row.map((cell,col)=>col===0?<th key={col} scope="row" style={{textAlign:alignment(col)}}><MathText text={cell}/></th>:<td key={col} style={{textAlign:alignment(col)}}><MathText text={cell}/></td>)}</tr>)}</tbody>
  </table></div>;
  return <p key={index}>{lines.map((line,lineIndex)=><Fragment key={lineIndex}>{lineIndex>0&&<br/>}<MathText text={line}/></Fragment>)}</p>;
 })}</div>;
}

export function PedagogicalCorrection({text}:{text:string}) {
 return <PedagogicalText text={text} tableLabel="Tableau de correction" correction/>;
}

